module.exports = __webpack_public_path__ + "img/2.08076c56.png";